import { API_BASE_URL } from '../config/api';

// A data: URI logo comes back as the public /share/logo/:slug image, and a
// club may store a site-relative logo path; the API's origin serves both. On
// the web that's this origin ('/api' → ''); in the native app the page runs
// on localhost, so any single-"/" path needs the API's absolute origin.
const API_ORIGIN = API_BASE_URL.replace(/\/api$/, '');

export const apiAssetSrc = (url) => (url && url.startsWith('/') && !url.startsWith('//') ? `${API_ORIGIN}${url}` : url);
